const panelCfg = JSON.parse(localStorage.getItem('panelCfg'));

export const state = {
    cfg: panelCfg
};

export const getters = {
    get(state) {
        return state.cfg;
    }
};

export const mutations = {
    setConfig(state, cfg) {
        state.cfg = cfg;
        localStorage.setItem('panelCfg', JSON.stringify(cfg));
    }
};

export const actions = {
    setConfig({commit}, info) {
        commit('setConfig', info);
    }
}